import authService from 'services/authService';
import { i18nInit } from '../internationalization/config';
import config from 'root/../config';

const request = require('superagent');

const languageService = {
    init : () => {
        request.get(config.apiAppUrl + config.APIs.getLanguages).then((res) => {
            const languageDetails = JSON.parse(res.text);

            if (languageService.getUserLanguage() == null){
                languageService.storeUserLanguage(languageDetails.DEFAULT_LANGUAGE);
                i18nInit.changeLanguage(languageDetails.DEFAULT_LANGUAGE);
            }else{
                i18nInit.changeLanguage(languageService.getUserLanguage());
            }
            if(languageService.getDefaultLanguage() === null){
                languageService.storeDefaultLanguage(languageDetails.DEFAULT_LANGUAGE);   
            }
            languageService.storeAvailableLanguages(languageDetails.LANGUAGES);
        })
    },
    changeLanguageOnServer : (language) => {
        let queryObject = {
            auth_token : authService.getToken(),
            language_id: language.LANGUAGE_ID
        }

        return (request.post(config.apiAppUrl + config.APIs.setLanguage)
                .accept('application/json')
                .send(queryObject))
    },
    changeLanguage : (language,sendToServer = true) => {
        i18nInit.changeLanguage(language.LANGUAGE_CODE);
        languageService.storeUserLanguage(language.LANGUAGE_CODE);
        if(sendToServer){
            languageService.changeLanguageOnServer(language).then(()=>{
                window.location.reload();
            })
        }
    },
    getAvailableLanguages : () => {
        const availableLanguages = window.localStorage.getItem("availableLanguages");
        if (availableLanguages != null){
            return JSON.parse(availableLanguages);
        }
        return [];
    },
    storeAvailableLanguages : (availableLanguages) => {
        window.localStorage.setItem("availableLanguages",JSON.stringify(availableLanguages));
    },
    getUserLanguage : () => (
        window.localStorage.getItem("userLanguage")
    ),
    storeUserLanguage : (languageCode) => (
        window.localStorage.setItem("userLanguage",languageCode)
    ),
    getDefaultLanguage : () => (
        window.localStorage.getItem("defaultLanguage")
    ),
    storeDefaultLanguage : (languageCode) => (
        window.localStorage.setItem("defaultLanguage",languageCode)
    ),
    getLanguageSettingsByCode : (languageCode) => {
        const availableLanguages = languageService.getAvailableLanguages();
        return availableLanguages.find(language => language.LANGUAGE_CODE === languageCode)
    },
    clearSettings : () => {
        i18nInit.changeLanguage(window.localStorage.getItem("defaultLanguage"));

        window.localStorage.removeItem("userLanguage");
        window.localStorage.removeItem("availableLanguages");
        window.localStorage.removeItem("defaultLanguage");
    }
}

export default languageService;